import Vue from 'vue';

// Конверит 2400 в "2 400 ₽"
Vue.filter('toCurrency', function(value) {
    value = 1 * value;
    if (value === 0) return '0';
    var formatter = new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.filter('formatNumber', function(value) {
    value = 1 * value;
    if (value === 0) return '0';
    var formatter = new Intl.NumberFormat('ru-RU', {
        style: 'decimal'
    });
    return formatter.format(value);
});

// Вырезает и возвращает из URL доменное имя
Vue.filter('extractHostname', function(url) {
    var hostname;
    if (url.indexOf('//') > -1) {
        hostname = url.split('/')[2];
    } else {
        hostname = url.split('/')[0];
    }

    // find & remove port number
    hostname = hostname.split(':')[0];
    // find & remove "?"
    hostname = hostname.split('?')[0];

    return hostname;
});



// WEBPACK FOOTER //
// ./src/utils/filters.js